const baseTheme = {
  fonts: {
    primary: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    mono: '"JetBrains Mono", "Fira Code", "Courier New", monospace',
  },

  fontSizes: {
    xs:   '0.75rem',
    sm:   '0.8125rem',
    md:   '0.9375rem',
    lg:   '1.0625rem',
    xl:   '1.25rem',
    xxl:  '1.5rem',
    xxxl: '1.875rem',
  },

  fontWeights: {
    light:    300,
    normal:   400,
    medium:   500,
    semibold: 600,
    bold:     700,
  },

  spacing: {
    xs:  '0.25rem',
    sm:  '0.5rem',
    md:  '1rem',
    lg:  '1.5rem',
    xl:  '2rem',
    xxl: '3rem',
  },

  borderRadius: {
    sm:    '8px',
    md:    '12px',
    lg:    '16px',
    xl:    '20px',
    round: '50%',
  },

  transitions: {
    fast:   '0.15s ease',
    normal: '0.25s ease',
    slow:   '0.4s ease',
  },

  breakpoints: {
    mobile:  '480px',
    tablet:  '768px',
    desktop: '1024px',
    wide:    '1280px',
  },
};

// ── Tema Claro ───────────────────────────────────────────────────────────────
export const lightTheme = {
  ...baseTheme,
  colors: {
    // Brand — Teal (Purity style)
    primary:      '#4FD1C5',   // Teal 300
    primaryDark:  '#38B2AC',   // Teal 400
    primaryLight: '#81E6D9',   // Teal 200

    secondary: '#718096',      // Gray 500

    // Semantic
    success: '#48BB78',        // Green 400
    danger:  '#FC8181',        // Red 400
    warning: '#F6AD55',        // Orange 400
    info:    '#63B3ED',        // Blue 400

    // Backgrounds
    background:      '#F7FAFC',  // Gray 50 (very light)
    backgroundLight: '#FFFFFF',
    backgroundDark:  '#EDF2F7',  // Blue-gray 100

    // Text
    textPrimary:   '#2D3748',   // Gray 800
    textSecondary: '#718096',   // Gray 500
    textLight:     '#A0AEC0',   // Gray 400

    // Borders
    border:      '#E2E8F0',     // Blue-gray 200
    borderLight: '#EDF2F7',     // Blue-gray 100

    // Status
    paid:    '#48BB78',
    pending: '#F6AD55',
    overdue: '#FC8181',

    // Sidebar — WHITE (Purity style)
    sidebarBg:     '#FFFFFF',
    sidebarText:   '#A0AEC0',   // Gray 400
    sidebarActive: '#2D3748',   // Gray 800 (active text)
    sidebarHover:  '#F7FAFC',   // Gray 50
  },

  shadows: {
    sm:   '0 1px 3px 0 rgba(0,0,0,0.07)',
    md:   '0 4px 12px 0 rgba(0,0,0,0.08)',
    lg:   '0 10px 40px 0 rgba(0,0,0,0.10)',
    xl:   '0 20px 60px 0 rgba(0,0,0,0.13)',
    card: '0 2px 12px 0 rgba(0,0,0,0.06)',
    sidebar: '4px 0 24px 0 rgba(0,0,0,0.06)',
  },
};

// ── Tema Oscuro ──────────────────────────────────────────────────────────────
export const darkTheme = {
  ...baseTheme,
  colors: {
    primary:      '#4FD1C5',
    primaryDark:  '#38B2AC',
    primaryLight: '#81E6D9',

    secondary: '#A0AEC0',

    success: '#68D391',
    danger:  '#FC8181',
    warning: '#F6AD55',
    info:    '#63B3ED',

    background:      '#1A202C',
    backgroundLight: '#2D3748',
    backgroundDark:  '#171923',

    textPrimary:   '#F7FAFC',
    textSecondary: '#A0AEC0',
    textLight:     '#718096',

    border:      '#2D3748',
    borderLight: '#1A202C',

    paid:    '#68D391',
    pending: '#F6AD55',
    overdue: '#FC8181',

    sidebarBg:     '#2D3748',
    sidebarText:   '#718096',
    sidebarActive: '#F7FAFC',
    sidebarHover:  '#1A202C',
  },

  shadows: {
    sm:   '0 1px 3px 0 rgba(0,0,0,0.3)',
    md:   '0 4px 12px 0 rgba(0,0,0,0.4)',
    lg:   '0 10px 40px 0 rgba(0,0,0,0.5)',
    xl:   '0 20px 60px 0 rgba(0,0,0,0.6)',
    card: '0 2px 12px 0 rgba(0,0,0,0.35)',
    sidebar: '4px 0 24px 0 rgba(0,0,0,0.4)',
  },
};

export const theme = lightTheme;
